module.exports = __webpack_public_path__ + "static/media/value-available-color.b0841bf5.png";